export default {
    streamNoteListedWebpages:
        'Por favor, tenga en cuenta que las páginas web enumeradas no son propiedad de Netvork LLP',
    streamNoteAdministrationCompliance:
        'Su administración y el cumplimiento de la ley aplicable por parte de sus propietarios no es responsabilidad de Netvork LLP.',
    streamNoteReportEmail:
        'Si tiene algún problema con las landing pages, infórmelo a la dirección de correo electrónico',
    respectfullyTeam: 'Con respeto, el equipo de Netvork',
    enterMessengerAccount: 'Introduce la cuenta del messenger',
    invalidTelegram: 'Dirección de Telegram no válida',
    invalidSkype: 'Dirección de Skype/Teams no válida',
};
